<div class="ml-2 flex h-16 flex-row space-x-5">
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionMonthNameTypeSelect
      [fixNgSelectBottom]="fractionMonthNameTypeSelect"
      data-cy="fractionMonthNameTypeSelect"
      class="fraction-type-select w-48"
      [items]="fractionMonthNameTypesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.type"
      (change)="typeChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionMonthNameTypeSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionMonthNameTypeSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div
          class="flex flex-row"
          [ngClass]="{
            'text-yellow-700': item.operator === fractionOperatorEnum.And
          }"
        >
          <div class="ml-1">{{ item.operator | uppercase }} -</div>
          <div class="ml-1 truncate">{{ item.label }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>

  <div
    *ngIf="
      fraction.type === fractionTypeEnum.MonthNameIs ||
      fraction.type === fractionTypeEnum.MonthNameIsNot
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionMonthNameValueSelect
      [fixNgSelectBottom]="fractionMonthNameValueSelect"
      data-cy="fractionMonthNameValueSelect"
      class="popup-55 w-48"
      [ngClass]="{
        'cursor-default': isDisabled === true
      }"
      [items]="fractionMonthNameValuesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.monthNameValue"
      (change)="monthNameValueChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionMonthNameValueSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionMonthNameValueSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>
    </ng-select>
  </div>
</div>
